import { render, staticRenderFns } from "./app-center-icon.vue?vue&type=template&id=533771e8&scoped=true"
import script from "./app-center-icon.vue?vue&type=script&lang=js"
export * from "./app-center-icon.vue?vue&type=script&lang=js"
import style0 from "./app-center-icon.vue?vue&type=style&index=0&id=533771e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533771e8",
  null
  
)

export default component.exports